module.exports = __webpack_public_path__ + "img/la-regular-400.55c57a74.svg";